// src/pages/LoginPage.jsx
import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ForgotPwd from "../components/ForgotPassword";

const ForgotPassword = () => {
  return (
    <>
      <Header />
      <ForgotPwd />
      <Footer />
    </>
  );
};

export default ForgotPassword;
